import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';
import Steps, { Step } from 'rc-steps';

class StepBar extends Component {
	shouldComponentUpdate = ({ currentStep, stepArray }) => {
		const lastProps = this.props;

		return (
			!isEqual(lastProps.currentStep, currentStep)
			|| !isEqual(lastProps.stepArray, stepArray)
		);
	}

	render() {
		const { currentStep, stepArray } = this.props;
		return (
			<Steps
				current={currentStep}
				labelPlacement="vertical"
			>
				<For
					index="index"
					each="item"
					of={stepArray}
				>
					<Step
						key={index}
						title={item}
					/>
				</For>
			</Steps>
		);
	}
}

StepBar.propTypes = {
	currentStep : PropTypes.number,
	stepArray   : PropTypes.array,
};

StepBar.defaultProps = {
	currentStep : 1,
	stepArray   : [],
};

export default StepBar;
